/**
 * cart
 */

/**
 * Kosár
 *
 * @author M.Tomi
 * @returns {undefined}
 */
var cart = {
    settings: {
        /**
         * konzol bejegyzéseket mutat
         * @boolen
         */
        debug: true,

        /**
         * Ajax hívás módja
         * @string GET|POST
         */
        ajaxMethod: 'GET',
        ajaxUrl : '/ajaxRequest/cartRequest'
    },
    init: function() {
        this.debugLog('init van');
        this._bindAddToCartClick();
        this._bindChangeProductQuantity();
        this._bindDelFromCartClick();
        this._bindWsPaymentSaveClick();
        this._bindWsAddressesSaveClick();
        this._bindWsCartNextClick();
        this._bindWsPaymentFinishClick();
    },
    _bindAddToCartClick : function() {
        $('.addToCart').click(function(e){
            var self = $(this);
            var pid = self.data('pid');
            var itemType = self.data('itemtype');
            if(pid) {
                cart.addToCart(pid, itemType, 1, function(response){
                    if(response.data.res === true) {
                        bootbox.dialog({
                            message: self.data('okmsg'),
                            className: 'kiesel-modal',
                            onEscape: true,
                            backdrop: true,
                            buttons: {
                                ok: {
                                    label: 'OK',
                                    className: 'btn-outline-gray',
                                },
                            },
                        });

                        // Google TagManager code
                        dataLayer.push({
                            'event': 'addToCart',
                            'ecommerce': {
                                'currencyCode': 'HUF',
                                'add': {                                // 'add' actionFieldObject measures.
                                    'products': [{                        //  adding a product to a shopping cart.
                                        'name': response.data.product.name + ' ('+response.data.product.name+')',
                                        'id': response.data.product.id,
                                        'price': response.data.product.price_gross,
                                        'category':  response.data.product.item_type,
                                        'quantity': 1
                                        //'brand': 'Google',
                                        //'variant': 'Gray',
                                    }]
                                }
                            }
                        });

                    }
                    else {
                        bootbox.alert(self.data('stokckoutmsg'))
                    }
                    cart.refreshLayoutInfos();
                });
            }
        });
    },
    _bindAddProductToCartClick : function() {
        $('.addProdToCart').click(function(e){
            var self = $(this);
            var pid = self.data('pid');
            var itemType = self.data('itemtype');
            if(pid) {
                cart.addToCart(pid, itemType, 1, function(response){
                    if(response.data.res !== true) {
                        bootbox.alert(self.data('stokckoutmsg'))
                    }
                    cart.refreshLayoutInfos();
                });
            }
        });
    },
    _bindDelFromCartClick : function() {
        $('.delFromCart').click(function(e){
            var pid = $(this).attr('data-pid');
            if(pid) {
                cart.delFromCart(pid, function(response){
                    cart.refreshLayoutInfos();
                    $('#cartItemRow-'+pid).fadeOut();

                    // Google TagManager code
                    var r = dataLayer.push({
                        'event': 'removeFromCart',
                        'ecommerce': {
                            'remove': {
                                'products': [{
                                    'name': response.data.product.name + ' ('+response.data.product.name+')',
                                    'id': response.data.product.id,
                                    'price': response.data.product.price_gross,
                                    'category':  response.data.product.item_type,
                                    'quantity': 1
                                    //'brand': 'Google',
                                    //'variant': 'Gray',
                                }]
                            }
                        }
                    });

                    console.log(r);
                });
            }
        });
    },
    _bindRemFromCartClick : function() {
        $('.remFromCart').click(function(e){
            var pid = $(this).attr('data-pid');
            var quantity = $(this).val();
            if(pid) {
                cart.remFromCart(pid, quantity, function(){
                    cart.refreshLayoutInfos();
                });
            }
        });
    },
    _bindChangeProductQuantity : function() {
        $('.itemQuantity').on('change', function (e) {
            var self = $(this);
            var pid = self.data('pid');
            var itemType = self.data('itemtype');
            if(pid) {
                cart.changeProductQuantity(pid, self.val(), function(response){
                    if(response.data.res !== true) {
                        bootbox.alert(self.data('stokckoutmsg'));
                    }

                    $('#cartItemRow-'+pid +' .rowSumPrice').text(
                        cart.numberFormat(response.data.sum_price)+' Ft'
                    );
                    cart.refreshLayoutInfos();
                });
            }
        });
    },
    _bindWsCartNextClick : function() {
        $('#cartNext').click(function(){
            location.href = $(this).attr('data-url');
        });
    },
    _bindWsPaymentSaveClick : function() {
        $('#wsPaymentSave').click(function(e){
            var payMode = $('input[name=payMode]:checked').val();
            var shippingMode = 'personal';
            cart.savePayAndShippingMode(payMode, shippingMode, function(response){
                location.href = response.redirect;
            });
        });
    },
    _bindWsAddressesSaveClick : function() {
        $('#wsShippingSave').click(function(e){
            var billingAddress = $('[name=billingAddress]:checked').val();
            cart.debugLog('_bindWsAddressesSaveClick');
            cart.debugLog(billingAddress);
            var shippingMode = 'personal';
            if(billingAddress > 0) {
                var shippingMode = 'personal'
                cart.saveAdresses(billingAddress, shippingMode, function (response) {
                    location.href = response.redirect;
                });
            }
            else {
                cart.error({
                    data:{
                        error:$('.addrError').attr('data-msg')
                    }
                }, ".addrError");
            }
        });
    },
    _bindWsPaymentFinishClick : function() {
        $('#paymentFinish').click(function(e){
            var aszfCheckbox = $('input[name=aszf]');
            if(!aszfCheckbox.prop('checked')) {
                e.preventDefault();
                cart.error({
                    data:{
                        error:$('.aszfError').attr('data-msg')
                    }
                }, ".aszfError");
            }
        });
    },
    addToCart: function(itemId, itemtype, qunatity, callback) {
        this.debugLog('call ajax (addToCart)', itemId, itemtype, qunatity);
        $.ajax({
            method : 'POST',
            url : cart.settings.ajaxUrl+'/add',
            data: {'items' : [{
                itemID: itemId,
                itemType: itemtype,
                quantity: qunatity
            }]},
            success: function(response) {
                cart.debugLog(response);
                if(callback !== 'undefined') {
                    callback($.parseJSON(response));
                }
            }
        });
    },
    subFromCart : function(itemId, qunatity, callback) {
        this.debugLog('call ajax (subFromCart)', itemId, qunatity);
        $.ajax({
            method : 'POST',
            url : cart.settings.ajaxUrl+'/sub',
            data: {
                itemID: itemId,
                quantity: qunatity
            },
            success: function(response) {
                cart.debugLog(response);
                if(callback !== 'undefined') {
                    callback();
                }
            }
        });
    },
    delFromCart : function(itemId, callback) {
        this.debugLog('call ajax (delFromCart)', itemId);
        $.ajax({
            method : 'POST',
            dataType: 'json',
            url : cart.settings.ajaxUrl+'/del',
            data: {
                itemID: itemId
            },
            success: function(response) {
                cart.debugLog(response);
                if(callback !== 'undefined') {
                    callback(response);
                }
            }
        });
    },
    remFromCart : function(itemId, qunatity, callback) {
        this.debugLog('call ajax (remFromCart)', itemId);
        $.ajax({
            method : 'POST',
            url : cart.settings.ajaxUrl+'/sub',
            data: {
                itemID: itemId,
                quantity: qunatity
            },
            success: function(response) {
                cart.debugLog(response);
                if(callback !== 'undefined') {
                    callback();
                }
            }
        });
    },
    changeProductQuantity : function(itemId, qunatity, callback) {
        this.debugLog('call ajax (changeProductQuantity)', itemId, qunatity);
        $.ajax({
            method : 'POST',
            dataType: 'json',
            url : cart.settings.ajaxUrl+'/change',
            data: {
                itemID: itemId,
                quantity: qunatity
            },
            success: function(response) {
                cart.debugLog(response);
                if(callback !== 'undefined') {
                    callback(response);
                }
            }
        });
    },
    getInfo : function(callback) {
        this.debugLog('call ajax (getInfo)');
        $.ajax({
            method : 'POST',
            dataType: 'json',
            url : cart.settings.ajaxUrl+'/getInfo',
            success: function(response) {
                cart.debugLog(response);
                if(callback !== 'undefined') {
                    console.log(response);
                    callback(response);
                }
            }
        });
    },
    refreshLayoutInfos : function() {
        this.getInfo(function(response){
            $('#cartTotalCost').text(
                cart.numberFormat(response.data.cartTotalCost)
            );
            $('#cartItemNum').text(response.data.cartItemNo);
        });
    },
    savePayAndShippingMode : function(payMode, shippingMode, callback) {
        this.debugLog('call ajax (savePayAndShippingMode)');
        $.ajax({
            method : 'POST',
            dataType: 'json',
            data: {
                payMode: payMode,
                shippingMode: shippingMode,
            },
            url : cart.settings.ajaxUrl+'/setPayAndShippingMode',
            success: function(response) {
                cart.debugLog(response);
                if(callback !== 'undefined') {
                    console.log(response);
                    callback(response);
                }
            }
        });
    },
    saveAdresses : function(billingAddress, shippingMode, callback) {
        this.debugLog('call ajax (saveAdresses)');
        $.ajax({
            method : 'POST',
            dataType: 'json',
            data: {
                billingAddress: billingAddress,
                shippingMode: shippingMode,
            },
            url : cart.settings.ajaxUrl+'/setAddresses',
            success: function(response) {
                cart.debugLog(response);
                if(callback !== 'undefined') {
                    console.log(response);
                    callback(response);
                }
            }
        });
    },
    numberFormat : function(val) {
        var format = wNumb({
            mark: '.',
            thousand: ' ',
            prefix: '',
            postfix: '',
            decimals: 0,
        });

        return format.to(val);
    },
    error: function(error, targetSelector){
        for (var prop in error.data) {
            if (error.data.hasOwnProperty(prop)) {
                var div = '<div class="alert alert-danger"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
                div += error.data[prop];
                div += '</div>';
                $(targetSelector).html(div);
                //$(window).scrollTop($(this.form).offset().top - 120).scrollLeft($(this.form).offset().left);
            }
        }
    },
    /**
     * Debuglog
     *
     * Settings alapján ír konzol debug bejegyzéseket
     * @param string variable
     */
    debugLog: function () {
        if (this.settings.debug) {
            console.log(arguments);
        }
    },
}


$(function(){
    cart.init();
});